import isValidCoverNumber from './is-valid-cover-number';

export default (cover_no: number) => {
  if (isValidCoverNumber(cover_no)) {
    const scn = cover_no.toString();
    return `${scn[0]} ${Number(scn[1]) === 1 ? 'Starboard' : 'Port'}`;
  }
  return cover_no;
};
